import { Button } from "@zendeskgarden/react-buttons";
import styled from "styled-components";
import type { ButtonProps } from "./buttonType";

const CustomButton = styled(Button)<{
  $color?: string;
  $hoverColor?: string;
  $textColor?: string;
  $fullWidth?: boolean;
  $borderColor?: boolean;
}>`
  background-color: ${({ $color }) => $color ?? "#f5f5f5"};
  color: ${({ $textColor }) => $textColor ?? "#1f2937"};
  border-radius: 4px;
  font-weight: 400;
  padding: 6px 14px;
  transition: all 0.2s ease-in-out;
  align-items: center;
  gap: 6px;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  font-size: 14px;
  border: ${({ $borderColor }) => ($borderColor ? "none" : "1px solid #e5e7eb")};

  &:hover {
    background-color: ${({ $hoverColor }) => $hoverColor ?? "#e5e7eb"};
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export default function ButtonDefault({
  title,
  color,
  hoverColor,
  textColor,
  icon: Icon,
  iconPosition = "start",
  onClick,
  fullWidth = false,
  disabled,
  border
}: ButtonProps) {
  return (
    <CustomButton
      onClick={onClick}
      $color={color}
      $hoverColor={hoverColor}
      $textColor={textColor}
      $fullWidth={fullWidth}
      disabled={disabled}
      $borderColor={border}
      isPrimary
    >
      <IconWrapper>
        {Icon && iconPosition === "start" && <span><Icon /></span>}
        {title}
        {Icon && iconPosition === "end" && <span><Icon /></span>}
      </IconWrapper>
    </CustomButton>
  );
}
